@for (row of linkList; track $index) {
  <div class="flex grow flex-wrap">
    @for (cell of row; track $index) {
      <div class="flex grow flex-wrap pb-2 justify-center">
        <p-button
          [label]="cell.label"
          [icon]="cell.icon?.toString()"
          (click)="onSelect(cell)"
          [outlined]="cell.outlined ?? true"
          class="flex pr-2"
          [styleClass]="cell.class"
        />
      </div>
    }
  </div>
}
